import React, { useState, useEffect } from 'react';
import { rentalApi } from '../../../../api/rentalApi';

export default function RentalInventory({ activeSubTab, onTabChange, globalContract }) {
    const [items, setItems] = useState([]);
    const [masterVehicles, setMasterVehicles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showFleetSync, setShowFleetSync] = useState(false);
    const [newItem, setNewItem] = useState({
        name: '',
        internal_number: '',
        pricing_type: 'day',
        unit_price_net: '',
        vat_rate: 19,
        category: activeSubTab,
        individual_contract_text: ''
    });
    const [editItem, setEditItem] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showItemContractEditor, setShowItemContractEditor] = useState(false);
    const [contractItem, setContractItem] = useState(null);

    useEffect(() => {
        fetchItems();
        if (activeSubTab === 'vehicle') fetchMasterVehicles();
    }, []);

    useEffect(() => {
        setNewItem(prev => ({ ...prev, category: activeSubTab }));
        if (activeSubTab === 'vehicle' && masterVehicles.length === 0) fetchMasterVehicles();
    }, [activeSubTab]);

    const fetchItems = async () => {
        try {
            const data = await rentalApi.getItems();
            setItems(data);
        } catch (err) {
            console.error('Error fetching items:', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchMasterVehicles = async () => {
        try {
            const data = await rentalApi.getMasterVehicles();
            setMasterVehicles(data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleAddItem = async (e) => {
        e.preventDefault();
        try {
            await rentalApi.createItem({ ...newItem, category: activeSubTab });
            setShowAddModal(false);
            fetchItems();
            setNewItem({ name: '', internal_number: '', pricing_type: 'day', unit_price_net: '', vat_rate: 19, category: activeSubTab, individual_contract_text: '' });
        } catch (err) {
            alert('Fehler beim Anlegen');
        }
    };

    const handleImportVehicle = async (v) => {
        try {
            await rentalApi.createItem({
                name: `${v.make} ${v.model} (${v.license_plate})`,
                internal_number: v.internal_name,
                pricing_type: 'day',
                unit_price_net: 0,
                category: 'vehicle',
                source_type: 'master',
                master_vehicle_id: v.id
            });
            fetchItems();
            setShowFleetSync(false);
        } catch (err) {
            alert('Fehler beim Import');
        }
    };

    const handleUpdateItem = async (e) => {
        e.preventDefault();
        try {
            await rentalApi.updateItem(editItem.id, editItem);
            setShowEditModal(false);
            setEditItem(null);
            fetchItems();
        } catch (err) {
            alert('Fehler beim Speichern der Änderungen');
        }
    };

    const handleDeleteItem = async (id) => {
        if (!window.confirm('Möchtest du dieses Objekt wirklich löschen?')) return;
        try {
            await rentalApi.deleteItem(id);
            fetchItems();
        } catch (err) {
            alert(err.response?.data?.error || 'Fehler beim Löschen');
        }
    };

    const handleSaveItemContract = async (e) => {
        e.preventDefault();
        try {
            await rentalApi.updateItem(contractItem.id, contractItem);
            setShowItemContractEditor(false);
            fetchItems();
        } catch (err) {
            alert('Fehler beim Speichern des Vertrags');
        }
    };

    const filteredItems = items.filter(item => {
        const cat = item.category?.toLowerCase();
        if (activeSubTab === 'other') return cat === 'other' || cat === 'sonstiges';
        return cat === activeSubTab;
    });

    const getStatusLabel = (item) => {
        if (!item.active) return <span className="status-pill-tiny busy"><span className="dot" style={{ background: '#ef4444' }} /> BELEGT</span>;
        return <span className="status-pill-tiny active"><span className="dot" style={{ background: '#10b981' }} /> BEREIT</span>;
    };

    return (
        <div className="rental-inventory premium-card" style={{ padding: '0', overflow: 'hidden' }}>
            <div className="inventory-header" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', padding: '16px 20px', borderBottom: '1px solid var(--p-slate-100)', background: '#f8fafc' }}>
                {activeSubTab === 'vehicle' && (
                    <button className="rental-btn-primary" style={{ background: 'var(--p-slate-800)', color: '#ffffff', boxShadow: 'none', padding: '8px 16px', fontSize: '0.75rem' }} onClick={() => setShowFleetSync(true)}>
                        FUHRPARK-SYNC
                    </button>
                )}
                <button className="rental-btn-primary" style={{ padding: '8px 16px', fontSize: '0.75rem' }} onClick={() => setShowAddModal(true)}>
                    + OBJEKT ERFASSEN
                </button>
            </div>

            {loading ? <div style={{ padding: '40px', textAlign: 'center', color: 'var(--p-slate-400)', fontSize: '0.8rem', fontWeight: '700' }}>DATEN WERDEN GELADEN...</div> : (
                <div className="modern-table-wrapper" style={{ padding: '0 10px 10px 10px' }}>
                    <table className="premium-style-table" style={{ marginTop: '10px' }}>
                        <thead>
                            <tr>
                                <th style={{ width: '80px', textTransform: 'none', color: 'var(--p-slate-500)' }}>Int.</th>
                                <th style={{ textTransform: 'none', color: 'var(--p-slate-500)' }}>Bezeichnung</th>
                                <th style={{ textAlign: 'center', textTransform: 'none', color: 'var(--p-slate-500)' }}>Kategorie</th>
                                <th style={{ textAlign: 'right', textTransform: 'none', color: 'var(--p-slate-500)' }}>Preis Netto</th>
                                <th style={{ textAlign: 'center', textTransform: 'none', color: 'var(--p-slate-500)' }}>Status</th>
                                <th style={{ textAlign: 'right', textTransform: 'none', color: 'var(--p-slate-500)' }}>Aktionen</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredItems.length === 0 ? (
                                <tr>
                                    <td colSpan="6" style={{ padding: '40px', textAlign: 'center', color: 'var(--p-slate-300)', fontSize: '0.8rem' }}>Keine Objekte in dieser Kategorie gefunden.</td>
                                </tr>
                            ) : (
                                filteredItems.map(item => (
                                    <tr key={item.id} style={{ borderBottom: '1px solid var(--p-slate-50)', transition: 'background 0.2s' }} onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                                        <td style={{ fontWeight: '800', color: 'var(--optimox-blue)' }}>#{item.internal_number || '---'}</td>
                                        <td style={{ fontWeight: '700', fontSize: '0.8rem', color: 'var(--p-slate-800)' }}>{item.name}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            <span style={{ background: 'var(--p-slate-100)', color: 'var(--p-slate-600)', fontSize: '0.6rem', fontWeight: '800', padding: '3px 8px', borderRadius: '6px' }}>
                                                {item.category?.toUpperCase()}
                                            </span>
                                        </td>
                                        <td style={{ textAlign: 'right', color: 'var(--p-slate-900)', fontWeight: '800', fontSize: '0.8rem' }}>
                                            {parseFloat(item.unit_price_net).toFixed(2)} €
                                            <span style={{ fontSize: '0.65rem', color: 'var(--p-slate-400)', marginLeft: '4px', fontWeight: '600' }}>/ {item.pricing_type}</span>
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            <span style={{ fontSize: '0.6rem', padding: '3px 8px', borderRadius: '6px', background: item.active ? '#dcfce7' : '#fee2e2', color: item.active ? '#166534' : '#9f1239', fontWeight: '800' }}>
                                                {item.active ? 'BEREIT' : 'BELEGT'}
                                            </span>
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            <button 
                                                className="rental-btn-primary" 
                                                style={{ padding: '4px 10px', fontSize: '0.65rem', marginRight: '6px', background: 'var(--optimox-blue)', border: 'none', borderRadius: '6px', fontWeight: '800', color: '#fff', cursor: 'pointer' }} 
                                                onClick={() => { setContractItem(item); setShowItemContractEditor(true); }}
                                            >
                                                📄 Vertrag
                                            </button>
                                            <button 
                                                className="rental-btn-secondary" 
                                                style={{ padding: '4px 10px', fontSize: '0.65rem', marginRight: '6px', background: '#fff', border: '1px solid var(--p-slate-200)', borderRadius: '6px', fontWeight: '700', color: 'var(--p-slate-600)', cursor: 'pointer' }} 
                                                onClick={() => { setEditItem(item); setShowEditModal(true); }}
                                                onMouseEnter={e => { e.target.style.background = 'var(--p-slate-50)'; e.target.style.borderColor = 'var(--p-slate-300)'; }}
                                                onMouseLeave={e => { e.target.style.background = '#fff'; e.target.style.borderColor = 'var(--p-slate-200)'; }}
                                            >
                                                Bearbeiten
                                            </button>
                                            <button 
                                                className="rental-btn-secondary" 
                                                style={{ padding: '4px 10px', fontSize: '0.65rem', background: '#fff', border: '1px solid #fecdd3', borderRadius: '6px', fontWeight: '700', color: '#e11d48', cursor: 'pointer' }} 
                                                onClick={() => handleDeleteItem(item.id)}
                                                onMouseEnter={e => { e.target.style.background = '#fff1f2'; e.target.style.borderColor = '#fda4af'; }}
                                                onMouseLeave={e => { e.target.style.background = '#fff'; e.target.style.borderColor = '#fecdd3'; }}
                                            >
                                                Löschen
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Sync Modal */}
            {showFleetSync && (
                <div className="rental-modal-overlay">
                    <div className="rental-modal premium-card" style={{ maxWidth: '650px', padding: '24px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                            <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '800' }}>FUHRPARK-SYNCHRONISATION</h3>
                            <button onClick={() => setShowFleetSync(false)} className="close-btn">×</button>
                        </div>
                        <div className="modern-table-wrapper" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                            <table className="premium-style-table">
                                <thead>
                                    <tr>
                                        <th style={{ textTransform: 'none', color: 'var(--p-slate-500)' }}>Fahrzeug Name</th>
                                        <th style={{ textTransform: 'none', color: 'var(--p-slate-500)' }}>Kennzeichen</th>
                                        <th style={{ textAlign: 'right', textTransform: 'none', color: 'var(--p-slate-500)' }}>Aktion</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {masterVehicles.filter(mv => !items.find(i => i.master_vehicle_id === mv.id)).map(v => (
                                        <tr key={v.id} style={{ borderBottom: '1px solid var(--p-slate-50)' }}>
                                            <td style={{ fontWeight: '700', fontSize: '0.8rem', color: 'var(--p-slate-800)' }}>{v.internal_name} <span style={{ color: '#94a3b8', fontSize: '0.7rem', fontWeight: '600' }}>({v.make})</span></td>
                                            <td><span style={{ background: '#f8fafc', padding: '4px 8px', borderRadius: '6px', fontSize: '0.7rem', fontWeight: '700', border: '1px solid var(--p-slate-100)' }}>{v.license_plate}</span></td>
                                            <td style={{ textAlign: 'right' }}>
                                                <button className="rental-btn-primary" style={{ padding: '6px 12px', fontSize: '0.7rem', color: '#ffffff' }} onClick={() => handleImportVehicle(v)}>Import</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
            {/* Add Modal Modernized */}
            {showAddModal && (
                <div className="action-modal-overlay">
                    <div className="action-modal" style={{ width: '450px', maxHeight: '90vh', overflowY: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '24px' }}>
                            <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: '900' }}>NEUES OBJEKT ERFASSEN</h3>
                            <button onClick={() => setShowAddModal(false)} style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'var(--p-slate-300)', fontSize: '1.2rem' }}>✕</button>
                        </div>
                        <form onSubmit={handleAddItem}>
                            <div className="form-group-compact" style={{ marginBottom: '16px' }}>
                                <label style={{ fontSize: '0.65rem', fontWeight: '800', color: 'var(--p-slate-400)' }}>BEZEICHNUNG / NAME *</label>
                                <input type="text" required value={newItem.name} onChange={e => setNewItem({...newItem, name: e.target.value})} placeholder="z.B. Minibagger 1.5t" style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid var(--p-slate-100)', background: 'var(--p-slate-50)' }} />
                            </div>
                            <div className="form-row-multi" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                                <div className="form-group-compact">
                                    <label style={{ fontSize: '0.65rem', fontWeight: '800', color: 'var(--p-slate-400)' }}>INTERNE NUMMER</label>
                                    <input type="text" value={newItem.internal_number} onChange={e => setNewItem({...newItem, internal_number: e.target.value})} placeholder="z.B. B-001" style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid var(--p-slate-100)', background: 'var(--p-slate-50)' }} />
                                </div>
                                <div className="form-group-compact">
                                    <label style={{ fontSize: '0.65rem', fontWeight: '800', color: 'var(--p-slate-400)' }}>ABRECHNUNG</label>
                                    <select value={newItem.pricing_type} onChange={e => setNewItem({...newItem, pricing_type: e.target.value})} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid var(--p-slate-100)', background: 'var(--p-slate-50)' }}>
                                        <option value="day">Pro Tag</option>
                                        <option value="hour">Pro Stunde</option>
                                        <option value="flat">Pauschal</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-row-multi" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div className="form-group-compact">
                                    <label style={{ fontSize: '0.65rem', fontWeight: '800', color: 'var(--p-slate-400)' }}>PREIS NETTO (€)</label>
                                    <input type="number" step="0.01" value={newItem.unit_price_net} onChange={e => setNewItem({...newItem, unit_price_net: Math.max(0, e.target.value)})} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid var(--p-slate-100)', background: 'var(--p-slate-50)', fontWeight: '800' }} />
                                </div>
                                <div className="form-group-compact">
                                    <label style={{ fontSize: '0.65rem', fontWeight: '800', color: 'var(--p-slate-400)' }}>MWST. (%)</label>
                                    <input type="number" value={newItem.vat_rate} onChange={e => setNewItem({...newItem, vat_rate: e.target.value})} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid var(--p-slate-100)', background: 'var(--p-slate-50)' }} />
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '12px', marginTop: '30px' }}>
                                <button type="submit" className="rental-btn-primary" style={{ flex: 1, padding: '14px' }}>OBJEKT SPEICHERN</button>
                                <button type="button" className="rental-btn-secondary" style={{ flex: 1, padding: '14px' }} onClick={() => setShowAddModal(false)}>ABBRECHEN</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Edit Modal Modernized */}
            {showEditModal && editItem && (
                <div className="action-modal-overlay">
                    <div className="action-modal" style={{ width: '450px', maxHeight: '90vh', overflowY: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '24px' }}>
                            <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: '900' }}>OBJEKT BEARBEITEN</h3>
                            <button onClick={() => setShowEditModal(false)} style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'var(--p-slate-300)', fontSize: '1.2rem' }}>✕</button>
                        </div>
                        <form onSubmit={handleUpdateItem}>
                            <div className="form-group-compact" style={{ marginBottom: '16px' }}>
                                <label style={{ fontSize: '0.65rem', fontWeight: '800', color: 'var(--p-slate-400)' }}>BEZEICHNUNG / NAME *</label>
                                <input type="text" required value={editItem.name} onChange={e => setEditItem({...editItem, name: e.target.value})} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid var(--p-slate-100)', background: 'var(--p-slate-50)' }} />
                            </div>
                            <div className="form-row-multi" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                                <div className="form-group-compact">
                                    <label style={{ fontSize: '0.65rem', fontWeight: '800', color: 'var(--p-slate-400)' }}>INTERNE NUMMER</label>
                                    <input type="text" value={editItem.internal_number || ''} onChange={e => setEditItem({...editItem, internal_number: e.target.value})} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid var(--p-slate-100)', background: 'var(--p-slate-50)' }} />
                                </div>
                                <div className="form-group-compact">
                                    <label style={{ fontSize: '0.65rem', fontWeight: '800', color: 'var(--p-slate-400)' }}>ABRECHNUNG</label>
                                    <select value={editItem.pricing_type} onChange={e => setEditItem({...editItem, pricing_type: e.target.value})} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid var(--p-slate-100)', background: 'var(--p-slate-50)' }}>
                                        <option value="day">Pro Tag</option>
                                        <option value="hour">Pro Stunde</option>
                                        <option value="flat">Pauschal</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-row-multi" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div className="form-group-compact">
                                    <label style={{ fontSize: '0.65rem', fontWeight: '800', color: 'var(--p-slate-400)' }}>PREIS NETTO (€)</label>
                                    <input type="number" step="0.01" value={editItem.unit_price_net} onChange={e => setEditItem({...editItem, unit_price_net: Math.max(0, e.target.value)})} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid var(--p-slate-100)', background: 'var(--p-slate-50)', fontWeight: '800' }} />
                                </div>
                                <div className="form-group-compact">
                                    <label style={{ fontSize: '0.65rem', fontWeight: '800', color: 'var(--p-slate-400)' }}>MWST. (%)</label>
                                    <input type="number" value={editItem.vat_rate} onChange={e => setEditItem({...editItem, vat_rate: e.target.value})} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid var(--p-slate-100)', background: 'var(--p-slate-50)' }} />
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '12px', marginTop: '30px' }}>
                                <button type="submit" className="rental-btn-primary" style={{ flex: 1, padding: '14px', background: 'var(--p-slate-800)', color: '#ffffff' }}>ÄNDERUNGEN SPEICHERN</button>
                                <button type="button" className="rental-btn-secondary" style={{ flex: 1, padding: '14px' }} onClick={() => { setShowEditModal(false); setEditItem(null); }}>ABBRECHEN</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Dedicated Contract Editor Modal */}
            {showItemContractEditor && contractItem && (
                <div className="action-modal-overlay">
                    <div className="action-modal" style={{ width: '800px', height: '90vh', display: 'flex', flexDirection: 'column', background: '#fff', borderRadius: '24px', overflow: 'hidden' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '24px', borderBottom: '1px solid var(--p-slate-100)' }}>
                            <div>
                                <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: '900', color: 'var(--p-slate-900)' }}>📄 MIETVERTRAG INDIVIDUALISIEREN</h3>
                                <p style={{ margin: '4px 0 0 0', fontSize: '0.8rem', color: 'var(--p-slate-500)', fontWeight: '600' }}>Für Objekt: {contractItem.name}</p>
                            </div>
                            <button onClick={() => setShowItemContractEditor(false)} style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'var(--p-slate-300)', fontSize: '1.2rem' }}>✕</button>
                        </div>
                        <div style={{ flex: 1, overflowY: 'auto', padding: '24px' }}>
                            <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '12px', padding: '16px', marginBottom: '24px' }}>
                                <h4 style={{ margin: '0 0 8px 0', color: '#1e3a8a', fontSize: '0.9rem', fontWeight: '800' }}>Tipp für individuelle Verträge</h4>
                                <p style={{ margin: 0, color: '#1e40af', fontSize: '0.8rem', lineHeight: 1.5 }}>
                                    Du kannst hier spezifische Mietbedingungen nur für dieses Objekt definieren. Klicke auf "Allgemeinen Vertrag laden", um deinen globalen Mietvertrag als Basis in das Textfeld zu kopieren. Beim Generieren des PDFs werden diese Klauseln dann zusätzlich angehängt.
                                </p>
                                <button 
                                    type="button" 
                                    onClick={() => setContractItem({...contractItem, individual_contract_text: globalContract?.contract_text || ''})} 
                                    style={{ marginTop: '12px', background: '#2563eb', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '8px', fontSize: '0.8rem', fontWeight: '800', cursor: 'pointer' }}
                                >
                                    📥 Allgemeinen Vertrag laden
                                </button>
                            </div>
                            <div className="form-group-compact" style={{ height: 'calc(100% - 150px)' }}>
                                <label style={{ fontSize: '0.8rem', fontWeight: '900', color: 'var(--p-slate-700)', display: 'block', marginBottom: '12px' }}>VERTRAGSTEXT / BEDINGUNGEN FÜR {contractItem.name.toUpperCase()}</label>
                                <textarea 
                                    value={contractItem.individual_contract_text || ''} 
                                    onChange={e => setContractItem({...contractItem, individual_contract_text: e.target.value})} 
                                    placeholder="Gib hier spezifische Klauseln ein oder lade die allgemeine Vorlage..." 
                                    style={{ width: '100%', height: '100%', padding: '16px', borderRadius: '12px', border: '2px solid var(--p-slate-200)', background: '#fff', fontSize: '0.9rem', lineHeight: 1.6, resize: 'none' }} 
                                />
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '12px', padding: '24px', borderTop: '1px solid var(--p-slate-100)', background: 'var(--p-slate-50)' }}>
                            <button type="button" className="rental-btn-secondary" style={{ padding: '14px 24px' }} onClick={() => setShowItemContractEditor(false)}>ABBRECHEN</button>
                            <button type="button" className="rental-btn-primary" style={{ flex: 1, padding: '14px 24px' }} onClick={handleSaveItemContract}>VERTRAG SPEICHERN</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
